import OrdersArchiveScreenComponent from "./OrdersArchiveScreenComponent";
import {select} from "../../../store/store";
import {iRootDispatch, iRootState} from "../../../store/store";
import {RouteComponentProps, withRouter} from "react-router";
import {connect} from "react-redux";

interface OrdersArchiveScreenStateProps {
    
}

interface OrdersArchiveScreenDispatchProps {   
    
}

const selection = () => select((_models) => ({
   
}))

const mapStateToProps = (state: iRootState, ownProps: RouteComponentProps<{  }>): OrdersArchiveScreenStateProps => ({
    
    //
    ...selection()(state),
})

const mapDispatch = (_dispatch: iRootDispatch, _ownDispatch: OrdersArchiveScreenDispatchProps) => ({

    ..._ownDispatch
} as OrdersArchiveScreenDispatchProps);

type connectedProps =
    OrdersArchiveScreenStateProps
    & ReturnType<typeof mapDispatch>
export type OrdersArchiveScreenProps = connectedProps

export const OrdersArchiveScreen = withRouter(connect(
    mapStateToProps,
    mapDispatch as any
)(OrdersArchiveScreenComponent));
